import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @Input() blue = false;
  @Input() showCalibrationsNav = false;
  @Input() areaButtonText: string;
  @Input() areaButtonLink: string;
  menuOpened = false;

  constructor() { }

  ngOnInit() { }

  toggleMenu() { this.menuOpened = !this.menuOpened; }
}
